import axios from 'axios';
import api from '@/api/api';
import userApi from '@/api/v1/user';

// URL and endpoint constants
const LOGIN_URL = '/sessions';
const SIGNUP_URL = '/users/';
const SIGNOUT_URL = '/sessions';
const FB_LOGIN_URL = '/sessions/facebook';

export default {

  // User object will let us check authentication status
  user: {
    authenticated: !!localStorage.getItem('X-Auth-Token'),
    email: localStorage.getItem('X-User-Email'),
  },

  // Send a request to the login URL and save the returned JWT
  login(context, creds) {
    function succ(response) {
      localStorage.setItem('X-Auth-Token', response.headers['x-auth-token']);
      localStorage.setItem('X-User-Email', response.headers['x-user-email']);

      location.reload();
    }
    function err(error) {
      context.errors = error.response.data.errors;
    }

    api.post(LOGIN_URL, creds, succ, err);
  },

  signup(context, creds) {
    function succ(response) {
      if (context.subscribe) userApi.subscribeForNewsletter({ email: creds.user.email });
      context.success = response.data.message;
    }
    function err(response) {
      context.error = 'Niepoprawne dane.';
      context.errors = response.response.data;
      context.scrollToTop();
    }

    api.post(SIGNUP_URL, creds, succ, err);
  },

  fbLogin(context, token) {
    function succ(response) {
      localStorage.setItem('X-Auth-Token', response.headers['x-auth-token']);
      localStorage.setItem('X-User-Email', response.headers['x-user-email']);

      location.reload();
    }
    function err(response) {
      context.showSignup = true;
      const data = response.response.data;
      context.error = data.errors ? data.errors[0] : `Email ${data.email[0]}`;
    }
    const user = {
      token,
    };
    api.post(FB_LOGIN_URL, { user }, succ, err);
  },

  // remove the token to log out
  logout() {
    function removeToken() {
      localStorage.removeItem('X-Auth-Token');
      localStorage.removeItem('X-User-Email');

      location.reload();
    }
    api.delete(SIGNOUT_URL, removeToken, removeToken);
  },

  // TODO
  refreshToken() {

  },

  // Send email with reset password token
  forgotPassword(email) {
    const data = { user: { email } };
    return axios.post('/sessions/forgot_password', data);
  },

  resetPassword(data) {
    return axios.post('/sessions/reset_password', data);
  },

  confirmAccount(token) {
    return axios.post('/sessions/confirm_account', token);
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/auth/authService.js